<template>
  <v-dialog
    v-model="open"
    max-width="500px"
    @click:outside="closeModal()"
  >
    <v-card>
      <v-card-title>
        <span class="headline">Are you sure?</span>
      </v-card-title>

      <v-card-text>
        Clicking confirm will schedule the following PDS payment:
        <v-list dense>
          <v-list-item
            two-line
            class="pl-0"
          >
            <v-list-item-content>
              <v-list-item-title>Method</v-list-item-title>
              <v-list-item-subtitle>
                {{ paymentProfileTitle }}
              </v-list-item-subtitle>
            </v-list-item-content>
          </v-list-item>
          <v-list-item
            two-line
            class="pl-0"
          >
            <v-list-item-content>
              <v-list-item-title>Date</v-list-item-title>
              <v-list-item-subtitle>
                {{ paymentDate }}
              </v-list-item-subtitle>
            </v-list-item-content>
          </v-list-item>
          <v-list-item
            two-line
            class="pl-0"
          >
            <v-list-item-content>
              <v-list-item-title>Type</v-list-item-title>
              <v-list-item-subtitle>
                {{ paymentTypeTitle }}
              </v-list-item-subtitle>
            </v-list-item-content>
          </v-list-item>
          <v-list-item
            two-line
            class="pl-0"
          >
            <v-list-item-content>
              <v-list-item-title>Amount</v-list-item-title>
              <v-list-item-subtitle>${{ paymentAmount }}</v-list-item-subtitle>
            </v-list-item-content>
          </v-list-item>
        </v-list>
      </v-card-text>
      <v-card-actions>
        <v-spacer />
        <v-btn
          v-if="hasPermission('create ticket::make-payment')"
          color="blue darken-1"
          text
          :disabled="loadingModel"
          @click="makePayment()"
        >
          Confirm
        </v-btn>
        <disabled-for-lack-of-role-btn
          v-else
          text="Confirm"
          permission="create ticket::make-payment"
          :x-small="false"
          :text-button="true"
        />

        <v-btn
          color="blue darken-1"
          text
          @click="closeModal()"
        >
          Cancel
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import DisabledForLackOfRoleBtn from '@/views/DisabledForLackOfRoleBtn.vue';
import { mapActions, mapState } from 'vuex';

export default {
  name: 'ConfirmPDSPaymentModal',
  components: { DisabledForLackOfRoleBtn },
  props: {
    ticket: {
      type: Object,
      required: true,
    },
    confirmModal: {
      type: Boolean,
      required: false,
      default: false,
    },
    paymentProfile: {
      type: Number,
      required: true,
    },
    paymentProfiles: {
      type: Array,
      required: true,
    },
    paymentDate: {
      type: String,
      required: true,
    },
    paymentType: {
      type: Number,
      required: true,
    },
    paymentTypes: {
      type: Array,
      required: true,
    },
    paymentAmount: {
      type: String,
      required: true,
    },
  },
  data() {
    return {
      open: false,
      loadingModel: false,
      paymentData: null,
    };
  },

  computed: {
    ...mapState('ticket', ['outboundTicket']),
    paymentProfileTitle() {
      return this.paymentProfile
        ? this.paymentProfiles.find((p) => p.id === this.paymentProfile).title
        : '';
    },

    paymentTypeTitle() {
      return this.paymentType
        ? this.paymentTypes.find((p) => p.id === this.paymentType).title : '';
    },
  },

  watch: {
    confirmModal(newValue) {
      this.open = newValue;
    },
  },

  created() {
    this.open = this.confirmModal;
  },

  methods: {
    ...mapActions('loanProLoan', ['getAutopays']),
    ...mapActions('notification', ['setNotification']),

    closeModal() {
      this.$emit('closeModal');
    },

    generateRequestObj() {
      this.loadingModel = true;
      return {
        ticketId: this.$route.params.id,
        paymentDate: this.paymentDate,
        paymentAmount: this.paymentAmount,
        paymentAccount: this.paymentProfile,
        outboundCustomer: this.outboundTicket.customer.id,
      };
    },

    async makePayment() {
      this.loadingModel = true;
      const requestObject = this.generateRequestObj();

      // eslint-disable-next-line consistent-return
      await this.$axios
        .post(`api/v1/loanpro-customer/${this.ticket.lpCustomer.id}/rtgs-payment/${this.ticket.active_loan.id}/${this.paymentProfile}/make`, { ...requestObject })
        .then((res) => {
          this.loadingModel = false;

          this.paymentData = res.data;
          this.paymentModal = true;
          this.$emit('updatePayment', this.paymentData);

          this.setNotification({
            message: 'The PDS payment was scheduled successfully.',
            color: 'green',
          });
          // }
          this.getAutopays();
        })
        .catch((err) => {
          this.loadingModel = false;
          this.$emit('error');
          let message = 'We were unable to schedule/make this payment. Please try again. If error continues, please contact your supervisor';
          if (err.response.data.errors) {
            // eslint-disable-next-line prefer-destructuring
            message = err.response.data.errors[Object.keys(err.response.data.errors)[0]][0];
          } else if (err.response.data.message) {
            message = err.response.data.message;
          }
          this.setNotification({
            message,
            color: 'red',
          });
        });
    },

  },
};
</script>

<style scoped>

</style>
